import {
  IonImg,
  IonText,
} from '@ionic/react';
import Fade from 'react-reveal/Fade';
import "./DownloadSection.css"

/**
 * Generates a static information component
 * detailing 'Download Ryde' and containing links to the different app stores
 * @returns information component
 */
const DownloadRyde = () => {
  return(
      <div className="prelogin-download-content">
          <Fade up><div className="prelogin-download-content">
              <IonText 
              className="prelogin-download-title font-baloo">
              Ready to Make a Delivery?</IonText>
              <IonText className="prelogin-download-address font-baloo font-m">Download the Ryde App now and book a delivery via RydeSEND</IonText>
          </div></Fade>
          <div className="prelogin-download-chip">
              <Fade up><a href="https://apps.apple.com/sg/app/ryde-taxi-car-hailing/id979806982">
                  <IonImg className="prelogin-download-fabs" style={{marginRight:'12px'}} src='icon/appStore.svg'/>
              </a></Fade>
              <Fade up><a href="https://play.google.com/store/apps/details?id=com.rydesharing.ryde&hl=en&gl=US">
                  <IonImg className="prelogin-download-fabs" style={{marginRight:'12px'}} src='icon/android.svg'/>
              </a></Fade>
              <Fade up><a href="https://appgallery.huawei.com/#/app/C101127379">
                  <IonImg className="prelogin-download-fabs" src='icon/appGallery.svg'/>
              </a></Fade>
          </div>
      </div>
  )
}
export default DownloadRyde